/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/secureConnectionSettingsMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a SecureConnectionSettings. */
export class SecureConnectionSettings {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a SecureConnectionSettings.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Deprecated endpoint due to VPN feature deprication. Retrieves secure connection settings from
   * ECS.
   * @summary Retrieves secure connection settings from ECS.
   * @param [options] The optional parameters
   * @returns Promise<Models.SecureConnectionSettingsGetSecureConnectionSettingsResponse>
   */
  getSecureConnectionSettings(options?: coreHttp.RequestOptionsBase): Promise<Models.SecureConnectionSettingsGetSecureConnectionSettingsResponse>;
  /**
   * @param callback The callback
   */
  getSecureConnectionSettings(callback: coreHttp.ServiceCallback<Models.SecureConnectionFlightSettings>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getSecureConnectionSettings(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.SecureConnectionFlightSettings>): void;
  getSecureConnectionSettings(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.SecureConnectionFlightSettings>, callback?: coreHttp.ServiceCallback<Models.SecureConnectionFlightSettings>): Promise<Models.SecureConnectionSettingsGetSecureConnectionSettingsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getSecureConnectionSettingsOperationSpec,
      callback) as Promise<Models.SecureConnectionSettingsGetSecureConnectionSettingsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getSecureConnectionSettingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/SecureConnectionSettings",
  responses: {
    200: {
      bodyMapper: Mappers.SecureConnectionFlightSettings
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
